export default "__VITE_ASSET__VvqR_a0A__"